import {applyResultCart} from "@Common/logic/checkout/common/apply-result-cart";
import {findMinE}        from "@Common/utils/collections";

export const setShippingAddress = (addressId, {itemId=undefined, apis, apiError, isInternalUser}) => ({
    action: async (cart) => {

        const oldShipping = itemId == null ? (
            cart.shipping
        ) : (
            cart.items.find((i) => i.itemId == itemId).shipping ?? cart.shipping
        );

        const serviceLevel = await (async () => {
            const shippingRates = await apis.next.shipping.getConsolidatedShippingRates({
                addressId,
                cartId: cart.cartId,
                isInternalUser,
            }).catch(error => {
                apiError.onChange(error?.error_code);
                return undefined;
            });
            if(shippingRates) {
                if (shippingRates.hasOwnProperty(oldShipping?.serviceLevel)) {
                    return oldShipping.serviceLevel;
                }

                apiError.onChange(null);
                return findMinE(Object.keys(shippingRates), (rate) => +shippingRates[rate].price);
            }
            return null;
        })();

        const resultCart = await apis.next.cart.updateCart({
            cartId: cart.cartId,
            "shipping": {
                ...oldShipping,
                addressId,
                serviceLevel: serviceLevel ?? "",
                itemId,
            }
        });

        return {
            change: applyResultCart(resultCart),
        };
    },
});

